export interface SectionContent {
  summary: string;
  question: string;
  detail: string;
}

export const FIELD_LIMITS = { summary: 400, question: 100, detail: 2400 };

export function validateSection(content: SectionContent): string | null {
  for (const field of ["summary", "question", "detail"] as const) {
    if (!content[field].trim()) return "Fülle alle drei Textfelder aus.";
    if (content[field].length > FIELD_LIMITS[field]) {
      return "Ein Textfeld überschreitet die angegebene Zeichenbegrenzung.";
    }
  }
  return null;
}

export function detailParagraphs(detail: string): string[] {
  return detail
    .trim()
    .split(/\r?\n\s*\r?\n/)
    .filter(Boolean);
}

function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (character) => {
    const entities: Record<string, string> = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    };
    return entities[character];
  });
}

/** Plain text only: no user-authored markup is interpreted in the HTML export. */
export function buildSectionHtml(content: SectionContent): string {
  const error = validateSection(content);
  if (error) throw new Error(error);
  const paragraphs = detailParagraphs(content.detail)
    .map((paragraph) => `    <p>${escapeHtml(paragraph)}</p>`)
    .join("\n");
  return `<div class="explainable-section">
  <p>${escapeHtml(content.summary.trim())}</p>
  <details>
    <summary>${escapeHtml(content.question.trim())}</summary>
${paragraphs}
  </details>
</div>`;
}
